import { Component, Input } from '@angular/core';
import { ButtonComponent } from '@edassist-ui/button';
import { ButtonDropDownItem } from '@edassist-ui/button-drop-down/button-drop-down-item';

@Component({
	selector: 'ea-button-drop-down',
	templateUrl: './button-drop-down.component.html',
	styleUrls: ['./button-drop-down.component.scss']
})
export class ButtonDropDownComponent extends ButtonComponent {
	@Input() buttonRole: string;
	@Input() dropDownItems: Array<ButtonDropDownItem>;

	caretUp = true;

	handleClick(): void {
		this.caretUp = !this.caretUp;
	}
}
